<div class="warning-container"
    [ngClass]="{'fullwidth': fullwidth}">
    <div class="row-1 column-1">
        <mat-icon class="warning-icon warning-color vertical-center">warning</mat-icon>
    </div>
    <div class="warning-text-color row-1 column-2">
        {{ text }}</div>
</div>